import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

//components
import TreeListItem from '../TreeListItem/TreeListItem.vue'
import UserListItem from '../UserListItem/UserListItem'

@Component({
  name: 'TreeList',
  components: { TreeListItem, UserListItem },
})
export default class TreeList extends Vue {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  @Prop({ type: Array }) items!: recipient.TreeListItem
  @Prop({ type: [String, Function] }) hasChildrenField!:
    | string
    | recipient.EvaluateTreeListItemHasChildrenFuction

    
}
